import React, {Component} from 'react';
import { Temas } from '../constants/temas';
import Loader from '@/components/template/loader';

export const ApplicationContext = React.createContext()
export const ApplicationContextConsumer = ApplicationContext.Consumer

export default class AppContext extends Component {
    
    state = {
        tema: Temas.DEFAULT,
        showLoad: false
    }

    setTema = (tema)=>{
        this.setState({ tema:tema });
    }

    showLoad = (value) => {
        this.setState({showLoad: value})
    }

    render(){
        let ctx = {
            tema:this.state.tema,
            setTema:this.setTema,
            showLoad: this.showLoad,
            isShowingLoad: this.state.showLoad
        };

        return (
            <ApplicationContext.Provider value={ctx}>
                <Loader visible={this.state.showLoad} />
                {this.props.children}
            </ApplicationContext.Provider>
        )
    }   
}